exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.spinner {\n  height: 20px;\n  width: 20px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n.spinner--1 {\n  border-top: 2px solid #c7c7c7;\n  animation: spinner1 600ms linear infinite;\n}\n@keyframes spinner1 {\nto {\n    transform: rotate(360deg);\n}\n}\n", ""]);

// exports
